import { combineReducers } from 'redux';
import wishlist from './wishlist.reducer';

const guestReducer = combineReducers({
  wishlist,
});

export default guestReducer;
